import { gql } from '@apollo/client';

export const CHARGE_PRICE_FRAGMENT = gql`
  fragment ChargePriceFields on ChargePrice {
    total
    markup
    netPrice
    discount
    salesTax
    markupType
    retailPrice
    discountType
    salesTaxType
    wholesalePrice
  }
`;
